import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATION, RouterNavigationAction } from '@ngrx/router-store';
import { ActivatedRouterStateSnapshot, ProductScope, ProductService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class ProductLoadingEffects {
  // Данный эффект подгружает продукт до загрузки pages
  productNavigate$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        map((action: RouterNavigationAction<ActivatedRouterStateSnapshot>) => action.payload.routerState),
        filter(({ context, params }) => context.type === 'ProductPage' && !!params.productCode),
        map(({ params: { productCode } }) => productCode as string),
        switchMap((productCode) =>
          this.productService
            .get(productCode, [ProductScope.DETAILS, ProductScope.ATTRIBUTES])
            .pipe(filter(Boolean), take(1)),
        ),
        map(() => undefined),
      ),
    {
      dispatch: false,
    },
  );

  constructor(
    private actions$: Actions,
    private productService: ProductService,
  ) {}
}
